/** 
    ------------ Product Page ----------------
**/



if ($("body").hasClass("template-product")){

  /* This function opens Notify me when customer is coming from Notify me from curated sets page */
  document.addEventListener("DOMContentLoaded", function () {
    // Only run if the URL contains ?notify=true
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.get("notify")) return;

    function openKlaviyoNotifyPopup() {
      const trigger = document.querySelector(".klaviyo-bis-trigger");

      if (trigger) {
        console.log("Klaviyo BIS trigger found — opening popup...");
        trigger.click();
      } else {
        console.log("Waiting for Klaviyo BIS trigger...");
        setTimeout(openKlaviyoNotifyPopup, 500);
      }
    }

    // Start checking for the trigger
    openKlaviyoNotifyPopup();
  });



  /* auto change addon variant as per product's variant */
  function AutoChangeAddonVariant(){
    const AddonSelect = document.querySelector('.single_addon_select');
    if (AddonSelect){
      var default_var_selected= document.querySelector('input.value_default_set').value;
      //console.log(default_var_selected);
      var selected_var_size= '';
      var get_addon_var_id= '';
      $('ul.main_product_var_linklist li').each(function(index) {
        var loop_var_title= $(this).text();
        if ($("body").hasClass("template-prd-addon-size")){
          var split_first_slash= loop_var_title.split(' / ')[0];
        } else if($("body").hasClass("template-prd-addon-color")){
          var split_first_slash= loop_var_title.split(' / ')[1];
        } else{
          
        }
        //var final_size_of_var= loop_var_title.replace(split_first_slash,'').replace('/ ','');
        var final_size_of_var= loop_var_title.replace(split_first_slash,'');
        var loop_var_id= $(this).attr('data-var-id');
        //console.log("loop_var_id: "+loop_var_id+", loop_size_title: "+final_size_of_var);
        if(default_var_selected == loop_var_id){
          selected_var_size= final_size_of_var;
        }
      });
      var get_enabled_addon_id= document.querySelector('select.select_addon_products').value;
      //console.log("get_enabled_addon_id: "+get_enabled_addon_id+", selected_var_size: "+selected_var_size);
      var select_enabled_addon= document.querySelector('.main_select_'+get_enabled_addon_id+' select');
      //var get_first_option_addon= select_enabled_addon.val();
      //console.log('get_first_option_addon: '+get_first_option_addon);
      $('.main_select_'+get_enabled_addon_id+' select option').each(function(index){
        var select_option_text= $(this).text();
        var select_option_id= $(this).val();
        //console.log('select_option_text: '+select_option_text+", select_option_id: "+select_option_id);
        if (select_option_text.indexOf(selected_var_size) >= 0){
          get_addon_var_id= parseInt(select_option_id);
          return false;
        }
      });
      var final_select_var='';
      if(get_addon_var_id != ''){
        select_enabled_addon.value = parseInt(get_addon_var_id); 
        select_enabled_addon.dispatchEvent(new Event("change"));
        final_select_var= parseInt(get_addon_var_id);
      } else{
        //console.log('size not exist in addon product');
        var get_first_val_enabled_addon= $('.main_select_'+get_enabled_addon_id+' select').find("option:first-child").val();
        //console.log('get_first_val_enabled_addon: '+get_first_val_enabled_addon);
        select_enabled_addon.value = parseInt(get_first_val_enabled_addon); 
        select_enabled_addon.dispatchEvent(new Event("change"));
        final_select_var= parseInt(get_first_val_enabled_addon);
      }
      localStorage.setItem('hidden_addon_var', final_select_var);
    } // check if addon div exist
  }

  /* update addon variant id on change of addon product select */
  const addon_prd_select = document.querySelector('select.single_addon_select');
  if (addon_prd_select){
    addon_prd_select.addEventListener('change', (event) => {
      var selected_addon_prd_id= parseInt(addon_prd_select.value);
      //console.log('selected_addon_prd_id: '+selected_addon_prd_id);
      localStorage.setItem('hidden_addon_var', selected_addon_prd_id);
    });
  }
  
  /* show addon products on change of addon category */
  function ChangeAddonCategory(prdIdSelected){
    var selected_prd_category= prdIdSelected;
    if($('#set_var_dropdown').val()){
      $('div.addon_single_product').hide();
      $('div.main_select_'+selected_prd_category).show();
    }
    AutoChangeAddonVariant();
  }

  /* change price on the add to cart button */
  /*
  function changePriceATC(evt) {
    const variant = evt.detail.variant;
    if (!variant) return;

    setTimeout(() => {
      var new_price = (evt.detail.variant.price)/100;
      var new_price_dollar = '$'+new_price;
      console.log("new_price: "+new_price_dollar);

      const $button = $('.product__info-container product-form .product-form__submit');
      if (!$button.length) return;

      let $priceSpan = $button.find('.price_on_atc_button');

      // If span does not exist (button re-rendered), create it
      if (!$priceSpan.length) {
        $priceSpan = $('<span>', {
          class: 'price_on_atc_button',
          'html': '&nbsp;| ' + new_price_dollar
        });

        $button.append($priceSpan);
      } else {
        $priceSpan.html(' &nbsp;| ' + new_price_dollar);
      }
    }, 800);
  }
  */

  
  /* document ready state pass selected variant */
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      AutoChangeAddonVariant();
      localStorage.setItem('hidden_set_addon_atc', 'no');
    }
  };

  /* on change addon category select */
  const category_select = document.querySelector('select.select_addon_products');
  if (category_select){
    category_select.addEventListener('change', (event) => {
      var selected_category_id= category_select.value;
      ChangeAddonCategory(selected_category_id);
    });
  }
  
  /* on change variant event */
  document.addEventListener('variant:change', function(evt) {
    //console.log(evt.detail.variant);
    //var changed_mainprd_var_id= evt.detail.variant.id;
    AutoChangeAddonVariant();
    // update price on add to cart button
    //changePriceATC(evt);
  });

  
  /* on change toggle addon */
  const checkbox = document.querySelector('input.toggle_addon_prd');
  if (checkbox){
    checkbox.addEventListener('change', (event) => {
      if (event.currentTarget.checked) {
        // checkbox is checked
        localStorage.setItem('hidden_set_addon_atc', 'yes');
        $('.addon-products').show();
        $('.addon_product_dropdowns').show();
      } else {
        localStorage.setItem('hidden_set_addon_atc', 'no');
        $('.addon-products').hide();
        $('.addon_product_dropdowns').hide();
      }
      //console.log(localStorage.getItem('hidden_set_addon_atc'));
    });
  }
  
  /* check if product is added to cart */
  $('.product-form__submit').click(function(){
    //console.log('add to cart clicked');
    var get_local_str_atc_set= localStorage.getItem('hidden_set_addon_atc');
    setTimeout(function(){
     if(get_local_str_atc_set == 'yes'){
       var get_var_addon= localStorage.getItem('hidden_addon_var');
       $('.atc-addon').attr('data-variant-id', get_var_addon);
       $('.atc-addon').click();
      } 
    }, 2000);
  });

  $(document).ready(function(){
    var get_page_url= window.location.href;
    if (get_page_url.includes('?sel-color=')) {
      var colorValue = get_page_url.split('?sel-color=')[1]; // gets value after ?sel-color=
      $('variant-radios').find('input[type="radio"][data-variant-handle="'+colorValue+'"]').trigger("click");
    }
  });


  /** This below script is responsible for automatically updating the selected variant next to the option label on product detail pages **/
  document.addEventListener('change', function (evt) {
      
    const input = evt.target;

    // Handle radio buttons
    if (input.matches('.non_color__fieldset_radio')) {
      console.log('change radio');
      if (!input.checked) return;

      const fieldset = input.closest('fieldset');
      if (!fieldset) return;

      const legendValue = fieldset.querySelector('[data-selected-value]');
      if (!legendValue) return;

      legendValue.innerHTML = '&nbsp;' + input.value;
    }

    // Handle dropdown selects
    if (input.matches('.select__select')) {
      const wrapper = input.closest('.variant-input-wrapper');
      if (!wrapper) return;

      const fieldset = wrapper.querySelector('[data-selected-value]');
      if (!fieldset) return;

      fieldset.innerHTML = '&nbsp;' + input.value;
    }
  });

  // auto show quick view on click of dummy quick view button
  $(document).on("click", ".qv_fbt_trigger", function() {
    var get_prd_id= $(this).attr('data-prd-id');
    $('.quick_view_fbt_'+get_prd_id).click();
  });
  
} // closing check if page is product page



/** 
    ------------ Bundles Collection Page ----------------
**/

if ($("body").hasClass("coll-designer-bundle")){
  
  /* js to add scroll to fix of subcollections for desktop view */
  $(document).ready(function($) {
    var scrollElement= $('section.spacing-section');
    var fixElement= $('.desk_card_collection_bundle');
    var scrollElementPosition = scrollElement.offset();
    var getParentWidth= $('.sub-collection').find('.slider-mobile-gutter').width();
    var getStickyHeaderHeight= $('sticky-header').height();
    $(window).scroll(function () {
      if($(window).scrollTop() > scrollElementPosition.top){
        fixElement.addClass("fix-subcoll");
        fixElement.css('top', getStickyHeaderHeight);
        fixElement.css('max-width', getParentWidth);
      } else {
        fixElement.removeClass("fix-subcoll"); 
      }
	});
    
    /* adding active class to sub-collection button */
    var get_bundle_selected_onload= window.location.href.split('#')[1];
    //console.log("get_bundle_selected_onload: "+get_bundle_selected_onload);
    if(typeof get_bundle_selected_onload != 'undefined'){
      $('.bundle_swap_button').addClass('button--secondary');
      $('.bundle-'+get_bundle_selected_onload).removeClass('button--secondary');
    } 
    
  }); // closing document ready event

  /* adding active class to sub-collection button on their click event */
  $(document).on('click', '.bundle_swap_button', function(){
    //console.log('click button bundle swap');
    setTimeout(function() {
      var get_selected_bundle= window.location.href.split('#')[1];
      $('.bundle_swap_button').addClass('button--secondary');
      $('.bundle-'+get_selected_bundle).removeClass('button--secondary');
    }, 200);
  });
  
} // closing check if page is bundle collection page


/** 
    ------------ Shop By Color Page ----------------
**/

if ($("body").hasClass("shop-by-color")){

  // this function runs on the change of sticky tabs of shop by color page
  // responsible for updating the active tabs and their fix scroll
  function changeTab($this){
    var allTabs = $('.tabs-curated-sets ul li');
    allTabs.removeClass('active');
    //$this.addClass('active');
    var get_target_bundle= $this.attr('data-tab-link');
    const targetBundle = document.getElementById(get_target_bundle);
    const headerOffset = 40; // height of your sticky header
    const bundlePosition = targetBundle.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = bundlePosition - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  // on click event of sticky tabs of shop by color page
  $(document).on('click', '.tabs-curated-sets ul li', function(){
    var $this= $(this);
    changeTab($this);
  });

  // on scroll event to highlight active tab
  $(window).on('scroll', function(){
    var scrollPos = $(window).scrollTop();
    var headerOffset = 40; // same as used above (adjust as needed)

    $('.tabs-curated-sets ul li').each(function(){
      var $this = $(this);
      var get_target_bundle = $this.attr('data-tab-link');
      var targetBundle = document.getElementById(get_target_bundle);

      if(targetBundle){
        var bundleTop = $(targetBundle).offset().top - headerOffset - 5; // small buffer
        var bundleBottom = bundleTop + $(targetBundle).outerHeight();

        if(scrollPos >= bundleTop && scrollPos < bundleBottom){
          if(!$this.hasClass('active')){ // only if not already active
            $('.tabs-curated-sets ul li').removeClass('active');
            $this.addClass('active');

            // ensure active tab is visible in the slider
            $this[0].scrollIntoView({
              behavior: "smooth",   // smooth scrolling
              inline: "center",     // center horizontally in view
              block: "nearest"      // don't affect vertical scroll
            });
          }
        }
      }
    });
  });


  $(document).ready(function($) {

    // js to add scroll to fix to tabs 
    var fixElement = $('.tabs-curated-sets');
    var scrollElementPosition = fixElement.offset();
    // adding placeholder element with same height to remove the jump while scroll to fix
    var placeholder = $('<div class="tabs-placeholder"></div>');
    placeholder.hide();
    fixElement.before(placeholder);
    $(window).on('scroll resize', function () {
      if ($(window).scrollTop() > scrollElementPosition.top) {
        if (!fixElement.hasClass("fix-tabs")) {
          placeholder.height(fixElement.outerHeight());
          placeholder.show();
          fixElement.addClass("fix-tabs");
          fixElement.css('top', 0);
        }
      } else {
        if (fixElement.hasClass("fix-tabs")) {
          fixElement.removeClass("fix-tabs");
          placeholder.hide();
        }
      }
    });
    
    
  }); // closing document ready event

}


/** 
    ------------ Quick View Popup ----------------
**/

/* quick view color swatch trigger check */
function triggerColorChangeQv(selected_color){
  setTimeout(function(){ 
    $('.quick-view__right').addClass("click");
    //$('.quick-view__right variant-radios fieldset.product-form__input').find('input[type="radio"][value="'+selected_color+'"]').trigger("click");
   }, 1000);
}


// on click Magnifying Glass icon on product card
$(document).on('click', 'summary.quick-view__summary', function(){
  var get_selected_color= $(this).attr('data-selected-color');
  triggerColorChangeQv(get_selected_color);
});

// on click Magnifying Glass icon on product card
$(document).on('click', 'summary.quick-view__summary', function(){
  var get_selected_color= $(this).attr('data-selected-color');
  triggerColorChangeQv(get_selected_color);
});





/** 
    ------------ Cart Drawer ----------------
**/

/* removing high index white color effect from item image and quantity on click of gift notes */
$(document).on('click', '#mini-cart .mini-cart .cart__notes', function(){
  var $thispopup= $(this);
  setTimeout(function(){ 
    if($thispopup.is("[open]")){
      $('#mini-cart .mini-cart cart-items ul li.cart-item-li .line-item-image').removeClass('high-index');
      $('#mini-cart .mini-cart cart-items ul li.cart-item-li .product-quantity').removeClass('high-index');
    } else{
      $('#mini-cart .mini-cart cart-items ul li.cart-item-li .line-item-image').addClass('high-index');
      $('#mini-cart .mini-cart cart-items ul li.cart-item-li .product-quantity').addClass('high-index');
    }
   }, 50);
});


/* pre-order consent form */
$(document).on('change', '#preorder-consent-checkbox', function(){
  if ($(this).is(":checked")) {
  $('.mini-cart-cta').removeClass('po_consent_enable');
  } else{
    $('.mini-cart-cta').addClass('po_consent_enable');
  }
});

/* Toggle edit button to show/hide line item variants dropdown */
$(document).on("click", ".edit_line_item .edit_line", function() {
  $(this).toggleClass('open');
  $(this).parent(".edit_line_item").find('.prd_selector').slideToggle();
});

/* This is responsible for editing the line items */
$(document).on("change", "#mini-cart .mini-cart cart-items .item_radio_change", function() {
  const $radio = $(this);
  const key = $radio.data("key");                  // line item key of old variant
  const newVariantId = parseInt($radio.data("varid"));     // new variant ID

  if (!key || !newVariantId) return;

  // Get current quantity from the same cart item
  const $cartItem = $radio.closest('.cart-item-li');
  const quantity = parseInt($cartItem.find('input.quantity__input').val()) || 1;

  const miniCart = document.querySelector('mini-cart');
  const sections = miniCart?.getSectionsToRender()?.map((s) => s.id) || [];

  // Step 1: remove old variant
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(() => {
    // Step 2: add new variant with the same quantity
    const body = JSON.stringify({
      items: [
        { id: newVariantId, quantity: quantity }
      ],
      sections,
      sections_url: window.location.pathname
    });

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body
    });
  })
  .then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(parsedState => {
    // Refresh cart drawer using theme’s method
    if (miniCart && typeof miniCart.renderContents === 'function') {
      miniCart.renderContents(parsedState);
    }

    // Trigger custom event for other scripts
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: parsedState }
    }));

    if (typeof miniCart?.open === 'function') {
      miniCart.open();
    }
  })
  .catch(error => {
    console.error("Error updating variant in mini cart:", error);
    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: { errorMessage: error.message }
    }));
  });
});


/* Clear Cart */
$(document).on('click', '#clear-cart-btn', function () {
  //console.log('test click');

  const miniCart = document.querySelector('mini-cart');
  const sections = miniCart?.getSectionsToRender()?.map((s) => s.id) || [];

  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      sections,
      sections_url: window.location.pathname
    })
  })
    .then(response => {
      if (!response.ok) throw new Error('Clear cart failed');
      return response.json();
    })
    .then(parsedState => {
      // Refresh cart drawer using theme’s method
      if (miniCart && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(parsedState);
      }

      // Trigger custom event for other scripts
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: parsedState }
      }));

      // Reopen/refresh drawer
      if (typeof miniCart?.open === 'function') {
        miniCart.open();
      }
    })
    .catch(err => {
      console.error("Error clearing cart:", err);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: err.message }
      }));
    });
});


/** 
    ------------ Curated Set Bundles Page ----------------
**/

if ($("body").hasClass("curated-sets-bundles")){


  // auto hide loft on load of quick view popup
  $(document).on("click", ".qv_curated_line", function() {
    var get_prd_id= $(this).attr('data-prdid');
    var get_multiblock_index= $(this).attr('data-multiblockindex');
    $('.quick_view_'+get_prd_id+'_'+get_multiblock_index).click();
  });

  /* 
    This function runs on opening the quick view popup on curated sets page
    is responsible for Auto scroll back to the products dropdown 
    on closing quick view popup 
  */
  let lastScrollTop = 0;
  // Store scroll when quick view is opened (before it jumps)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.quick-view__summary, .quick-view-btn')) {
      lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }
  });
  // Restore scroll when quick view drawer closes
  document.addEventListener('quickview:close', function () {
    setTimeout(() => {
      window.scrollTo({ top: lastScrollTop, left: 0, behavior: 'auto' });
    }, 0);
  });



  // this function runs on the change of sticky tabs of bundle products page
  // responsible for updating the active tabs and their fix scroll
  function changeTab($this){
    var allTabs = $('.tabs-curated-sets ul li');
    allTabs.removeClass('active');
    $this.addClass('active');
    var get_target_bundle= $this.attr('data-tab-link');
    const targetBundle = document.getElementById(get_target_bundle);
    const headerOffset = 20; // height of your sticky header
    const bundlePosition = targetBundle.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = bundlePosition - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  // on click event of sticky tabs of bundle products page
  $(document).on('click', '.tabs-curated-sets ul li', function(){
    var $this= $(this);
    changeTab($this);
  });
  

  // on scroll event to highlight active tab
  $(window).on('scroll', function(){
    var scrollPos = $(window).scrollTop();
    var headerOffset = 40; // same as used above (adjust as needed)

    $('.tabs-curated-sets ul li').each(function(){
      var $this = $(this);
      var get_target_bundle = $this.attr('data-tab-link');
      var targetBundle = document.getElementById(get_target_bundle);

      if(targetBundle){
        var bundleTop = $(targetBundle).offset().top - headerOffset - 5; // small buffer
        var bundleBottom = bundleTop + $(targetBundle).outerHeight();

        if(scrollPos >= bundleTop && scrollPos < bundleBottom){
          $('.tabs-curated-sets ul li').removeClass('active');
          $this.addClass('active');
        }
      }
    });
  });

  $(document).ready(function($) {

    /* js to add scroll to fix to tabs */
    var fixElement = $('.tabs-curated-sets');
    var scrollElementPosition = fixElement.offset();
    // adding placeholder element with same height to remove the jump while scroll to fix
    var placeholder = $('<div class="tabs-placeholder"></div>');
    placeholder.hide();
    fixElement.before(placeholder);
    $(window).on('scroll resize', function () {
      if ($(window).scrollTop() > scrollElementPosition.top) {
        if (!fixElement.hasClass("fix-tabs")) {
          placeholder.height(fixElement.outerHeight());
          placeholder.show();
          fixElement.addClass("fix-tabs");
          fixElement.css('top', 0);
        }
      } else {
        if (fixElement.hasClass("fix-tabs")) {
          fixElement.removeClass("fix-tabs");
          placeholder.hide();
        }
      }
    });
    
  }); // closing document ready event

  /* Swiper slider for product list under the bundle */
  new Swiper('.bundle_prds-swiper', {
    loop: false,
    spaceBetween: 10,
    simulateTouch: true,
    grabCursor: true,
    touchRatio: 1,
    touchAngle: 45,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      hide: false,
    },

    mousewheel: {
      forceToAxis: false,  // allow diagonal scroll detection
      sensitivity: 1,      // adjust as needed
      invert: false
    },

    freeMode: {
      enabled: true,       // allow free scrolling between slides
      momentum: true,      // enables inertia/smooth sliding
      momentumRatio: 1,    // speed factor for momentum
      momentumBounce: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2.5,  // Mobile
      },
      768: {
        slidesPerView: 2.5,  // Tablet
      },
      1024: {
        slidesPerView: 3.5,  // Desktop
      },
      1367: {
        slidesPerView: 4.5,  // Desktop
      }
    }
  });

  // this function runs on the change of COLOR radios of bundle products
  // responsible for updating the "OUT OF STOCK" SIZE variants
  function updateSoldOutSize(productID,selectedColor,multicolumnLoopIndex){
    
    // looping all products and storing the available and non-available products in their arrays
    var stockOutSizes = []; 
    var inStockSizes = [];
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      var current_opt_inv_qty= parseInt($(this).attr('data-var-inventory'));
      if (current_option_loop_text.indexOf(selectedColor) >= 0){
        var split_var_size= current_option_loop_text.split(' / ');
        if(current_opt_inv_qty < 1){
          stockOutSizes.push(split_var_size[1]);
        } else{
          inStockSizes.push(split_var_size[1]);
        }
      }
    });
    
    // adding a line-through the size variatiions, which are OUT OF STOCK
    $('li.'+productID+'_Size_'+multicolumnLoopIndex).each(function( index ) {
      $('li.'+productID+'_Size_'+multicolumnLoopIndex).removeClass('out-of-stock');
      $('li.'+productID+'_Size_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
      var current_pointer= $(this);
      var current_opt_value= current_pointer.attr('data-opt-value');
      if(jQuery.inArray(current_opt_value,stockOutSizes) > -1){
        current_pointer.addClass('out-of-stock');
        current_pointer.find('input').prop('disabled', true);
      }
    });
    
    // updating the selected SIZE text in it's dropdown summary 
    var get_current_size= $('.'+productID+'_size_selected_variant_'+multicolumnLoopIndex).text();
    
    // check if the currently selected size is OUT OF STOCK, then change the size to the first available one
    if(jQuery.inArray(get_current_size,stockOutSizes) > -1){
      if((inStockSizes.length > 0)){
        // change size to in stock size
        var get_first_available_size= inStockSizes[0];
        $('li.'+productID+'_Size_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop= $(this);
          var get_current_loop_size= current_pointer_loop.attr('data-opt-value');
          if(get_first_available_size == get_current_loop_size){
            current_pointer_loop.find('input.size_radio_change').prop('checked', true).trigger('change');
          }
        });
        $('.'+productID+'_facets_size_disclosure_'+multicolumnLoopIndex).show();
        $('.'+productID+'_no_size_'+multicolumnLoopIndex).hide();
      } else{
        // hide the top checkbox and show "NO SIZE AVAILABLE FOR THIS COLOR" message
        // implement same feature for by default page load
        $('li.'+productID+'_Size_'+multicolumnLoopIndex).addClass('out-of-stock');
        $('li.'+productID+'_Size_'+multicolumnLoopIndex).find('input').prop('disabled', true);
        $('.'+productID+'_facets_size_disclosure_'+multicolumnLoopIndex).hide();
        $('.'+productID+'_no_size_'+multicolumnLoopIndex).show();
        $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',0);
      }
    } else{
      // if current selected size is in stock then hide not available message and show dropdown
      $('.'+productID+'_facets_size_disclosure_'+multicolumnLoopIndex).show();
      $('.'+productID+'_no_size_'+multicolumnLoopIndex).hide();
    }
  } // end updateSoldOutSize()


  // this function runs on the change of SIZE radios of pillow bundle products
  // responsible for updating the "OUT OF STOCK" LOFT variants
  function updateSoldOutPillowLoft(productID,selectedSize,multicolumnLoopIndex){
    
    // looping all products and storing the available and non-available products in their arrays
    var stockOutLofts = []; 
    var inStockLofts = [];
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      var current_opt_inv_qty= parseInt($(this).attr('data-var-inventory'));
      if (current_option_loop_text.indexOf(selectedSize) >= 0){
        var split_var_loft= current_option_loop_text.split(' / ');
        if(current_opt_inv_qty < 1){
          stockOutLofts.push(split_var_loft[1]);
        } else{
          inStockLofts.push(split_var_loft[1]);
        }
      }
    });
    
    // adding a line-through the loft variatiions, which are OUT OF STOCK
    $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
      $('li.'+productID+'_Loft_'+multicolumnLoopIndex).removeClass('out-of-stock');
      $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
      var current_pointer= $(this);
      var current_opt_value= current_pointer.attr('data-opt-value');
      if(jQuery.inArray(current_opt_value,stockOutLofts) > -1){
        current_pointer.addClass('out-of-stock');
        current_pointer.find('input').prop('disabled', true);
      }
    });
    
    // updating the selected LOFT text in it's dropdown summary 
    var get_current_loft= $('.'+productID+'_loft_selected_variant_'+multicolumnLoopIndex).text();
    
    // check if the currently selected loft is OUT OF STOCK, then change the loft to the first available one
    if(jQuery.inArray(get_current_loft,stockOutLofts) > -1){
      if((inStockLofts.length > 0)){
        // change loft to in stock loft
        var get_first_available_loft= inStockLofts[0];
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop= $(this);
          var get_current_loop_loft= current_pointer_loop.attr('data-opt-value');
          if(get_first_available_loft == get_current_loop_loft){
            current_pointer_loop.find('input.loft_radio_change').prop('checked', true).trigger('change');
          }
        });
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
      } else{
        // hide the top checkbox and show "NO LOFT AVAILABLE FOR THIS SIZE" message
        // implement same feature for by default page load
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).addClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').prop('disabled', true);
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).hide();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).show();
        $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',0);
      }
    } else{
      // if current selected loft is in stock then hide not available message and show dropdown
      $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
      $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
    }
  } // end updateSoldOutPillowLoft()


  // this function runs on the change of SIZE radios of Duvet Insert bundle products
  // responsible for updating the "OUT OF STOCK" FILL and LOFT variants
  function updateSoldOutFillLoft(productID,selectedSize,multicolumnLoopIndex){
    //console.log('test click on change size variant');

    // looping all products and storing the available and non-available products in their arrays 
    var inStockNewFills = [];
    var inStockNewLofts = [];
    var stockOutSizeFillLofts = [];
    var instockSizeFillLofts = [];
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      var current_opt_inv_qty= parseInt($(this).attr('data-var-inventory'));
      if (current_option_loop_text.indexOf(selectedSize) >= 0){
        if(current_opt_inv_qty < 1){
          stockOutSizeFillLofts.push(current_option_loop_text);
        } else{
          instockSizeFillLofts.push(current_option_loop_text);
        }
      }
    });

    // check if the currently selected fill and loft is OUT OF STOCK, then change the fill,loft to the first available one
    var get_current_selected_fill= $('.'+productID+'_fill_selected_variant_'+multicolumnLoopIndex).text();
    var get_current_selected_loft= $('.'+productID+'_loft_selected_variant_'+multicolumnLoopIndex).text();
    var combine_selected_size_fill_loft= selectedSize+" / "+get_current_selected_fill+" / "+get_current_selected_loft;
    //console.log('combine_selected_size_fill_loft: '+combine_selected_size_fill_loft);

    if(jQuery.inArray(combine_selected_size_fill_loft,stockOutSizeFillLofts) > -1){
      //console.log('current combo out of stock');

      if((instockSizeFillLofts.length > 0)){
        //console.log('in stock fill,loft combo available');

        // change fill,loft to in stock fill,loft
        var get_first_available_size_fill_loft= instockSizeFillLofts[0];
        var get_final_available_fill_loft_split= get_first_available_size_fill_loft.split(" / ");
        var get_first_available_fill= get_final_available_fill_loft_split[1];
        var get_first_available_loft= get_final_available_fill_loft_split[2];
        //console.log("get_first_available_size_fill_loft: "+get_first_available_size_fill_loft+", get_first_available_fill: "+get_first_available_fill+", get_first_available_loft: "+get_first_available_loft);

        // store the new available fill,loft in two separate arrays
        $.each(instockSizeFillLofts, function( index, value ) {
          var split_new_available= value.split(' / ');
          var new_available_fill= split_new_available[1];
          var new_available_loft= split_new_available[2];
          if(jQuery.inArray(new_available_fill,inStockNewFills) < 0 ){
            inStockNewFills.push(new_available_fill);
          }
          if(value.indexOf(get_first_available_fill) >= 0){
            if(jQuery.inArray(new_available_loft,inStockNewLofts) < 0 ){
              inStockNewLofts.push(new_available_loft);
            }
          }
        });

        // change fill to in stock fill
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_fill= $(this);
          var get_current_loop_fill= current_pointer_loop_fill.attr('data-opt-value');
          if(get_first_available_fill == get_current_loop_fill){
            current_pointer_loop_fill.find('input.fill_radio_change').prop('checked', true).trigger('change');
          }
          // adding a line-through the fill variatiions, which are OUT OF STOCK
          if(jQuery.inArray(get_current_loop_fill,inStockNewFills) < 0){
            current_pointer_loop_fill.addClass('out-of-stock');
            current_pointer_loop_fill.find('input').prop('disabled', true);
          }
        });
        $('.'+productID+'_facets_fill_disclosure_'+multicolumnLoopIndex).show();
        $('.'+productID+'_no_fill_'+multicolumnLoopIndex).hide();

        // change loft to in stock loft
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_loft= $(this);
          var get_current_loop_loft= current_pointer_loop_loft.attr('data-opt-value');
          if(get_first_available_loft == get_current_loop_loft){
            current_pointer_loop_loft.find('input.loft_radio_change').prop('checked', true).trigger('change');
          }
          // adding a line-through the loft variatiions, which are OUT OF STOCK
          if(jQuery.inArray(get_current_loop_loft,inStockNewLofts) < 0){
            current_pointer_loop_loft.addClass('out-of-stock');
            current_pointer_loop_loft.find('input').prop('disabled', true);
          }
        });
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
        
      } else{
        //console.log('in-stock fill.loft not available');

        // hide the top checkbox and show "NO FILL MATERIAL AVAILABLE" & "NO LOFT AVAILABLE" message
        // implement same feature for by default page load
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).addClass('out-of-stock');
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).find('input').prop('disabled', true);
        $('.'+productID+'_facets_fill_disclosure_'+multicolumnLoopIndex).hide();
        $('.'+productID+'_no_fill_'+multicolumnLoopIndex).show();
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).addClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').prop('disabled', true);
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).hide();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).show();
        $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',0);
      } 
    } else{
      //console.log('current combo is in stock');

      // update line-through to out-of-stock variants of fill and loft
      if((instockSizeFillLofts.length > 0)){
        // store the new available fill,loft in two separate arrays
        $.each(instockSizeFillLofts, function( index, value ) {
          var split_new_available= value.split(' / ');
          var new_available_fill= split_new_available[1];
          var new_available_loft= split_new_available[2];
          if(jQuery.inArray(new_available_fill,inStockNewFills) < 0 ){
            inStockNewFills.push(new_available_fill);
          }
          if(value.indexOf(get_current_selected_fill) >= 0){
            if(jQuery.inArray(new_available_loft,inStockNewLofts) < 0 ){
              inStockNewLofts.push(new_available_loft);
            }
          }
        });

        // adding a line-through the fill variatiions, which are OUT OF STOCK
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Fill_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_fill= $(this);
          var get_current_loop_fill= current_pointer_loop_fill.attr('data-opt-value');
          if(jQuery.inArray(get_current_loop_fill,inStockNewFills) < 0){
            current_pointer_loop_fill.addClass('out-of-stock');
            current_pointer_loop_fill.find('input').prop('disabled', true);
          }
        });

        // adding a line-through the loft variatiions, which are OUT OF STOCK
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_loft= $(this);
          var get_current_loop_loft= current_pointer_loop_loft.attr('data-opt-value');
          if(jQuery.inArray(get_current_loop_loft,inStockNewLofts) < 0){
            current_pointer_loop_loft.addClass('out-of-stock');
            current_pointer_loop_loft.find('input').prop('disabled', true);
          }
        });

      }

      // if current selected fill,loft is in stock then hide not available message and show dropdown
      $('.'+productID+'_facets_fill_disclosure_'+multicolumnLoopIndex).show();
      $('.'+productID+'_no_fill_'+multicolumnLoopIndex).hide();
      $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
      $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
    }
    
  } // end updateSoldOutFillLoft()




  // this function runs on the change of FILL MATERIAL radios of Duvet Insert bundle products
  // responsible for updating the "OUT OF STOCK" LOFT variants
  function updateSoldOutLoft(productID,selectedFill,multicolumnLoopIndex){

    // looping all products and storing the available and non-available products in their arrays 
    var inStockNewLofts = [];
    var stockOutNewLofts = [];
    var get_current_selected_size= $('.'+productID+'_size_selected_variant_'+multicolumnLoopIndex).text();
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      var current_opt_inv_qty= parseInt($(this).attr('data-var-inventory'));
      if ((current_option_loop_text.indexOf(selectedFill+" / ") >= 0) && (current_option_loop_text.indexOf(get_current_selected_size) >= 0)){
        var split_var= current_option_loop_text.split(' / ');
        var split_var_loft= split_var[2];
        if(current_opt_inv_qty < 1){
          stockOutNewLofts.push(split_var_loft);
        } else{
          inStockNewLofts.push(split_var_loft);
        }
      }
    });
  
    // check if the currently selected fill and loft is OUT OF STOCK, then change the fill,loft to the first available one
    var get_current_selected_loft= $('.'+productID+'_loft_selected_variant_'+multicolumnLoopIndex).text();
    //console.log('get_current_selected_loft: '+get_current_selected_loft);

    if(jQuery.inArray(get_current_selected_loft,stockOutNewLofts) > -1){
      //console.log('current loft out of stock');

      if((inStockNewLofts.length > 0)){
        //console.log('in stock loft available');

        // change loft to first available in-stock loft
        var get_first_available_loft= inStockNewLofts[0];
        
        // change loft to in stock loft
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_loft= $(this);
          var get_current_loop_loft= current_pointer_loop_loft.attr('data-opt-value');
          if(get_first_available_loft == get_current_loop_loft){
            current_pointer_loop_loft.find('input.loft_radio_change').prop('checked', true).trigger('change');
          }
          // adding a line-through the loft variatiions, which are OUT OF STOCK
          if(jQuery.inArray(get_current_loop_loft,inStockNewLofts) < 0){
            current_pointer_loop_loft.addClass('out-of-stock');
            current_pointer_loop_loft.find('input').prop('disabled', true);
          }
        });
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
        
      } else{
        //console.log('in-stock loft not available');

        // hide the top checkbox and show "NO LOFT AVAILABLE" message
        // implement same feature for by default page load
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).addClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').prop('disabled', true);
        $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).hide();
        $('.'+productID+'_no_loft_'+multicolumnLoopIndex).show();
        $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',0);
      } 
    } else{
      //console.log('current loft is in stock');
      
      // update line-through to out-of-stock variants of fill and loft
      if((inStockNewLofts.length > 0)){
        
        // adding a line-through the loft variatiions, which are OUT OF STOCK
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).removeClass('out-of-stock');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).find('input').removeAttr('disabled');
        $('li.'+productID+'_Loft_'+multicolumnLoopIndex).each(function( index ) {
          var current_pointer_loop_loft= $(this);
          var get_current_loop_loft= current_pointer_loop_loft.attr('data-opt-value');
          if(jQuery.inArray(get_current_loop_loft,inStockNewLofts) < 0){
            current_pointer_loop_loft.addClass('out-of-stock');
            current_pointer_loop_loft.find('input').prop('disabled', true);
          }
        });

      }

      // if current selected loft is in stock then hide not available message and show dropdown
      $('.'+productID+'_facets_loft_disclosure_'+multicolumnLoopIndex).show();
      $('.'+productID+'_no_loft_'+multicolumnLoopIndex).hide();
    }
    
  } // end updateSoldOutLoft()

  // this function runs on the change of SIZE and COLOR radios of bundle products
  // responsible for updating the variation color image, and the variation details to add to the cart process
  function updateVariantOnChange(productID,variantType,selectedValue,multicolumnLoopIndex){
    $('.'+productID+'_'+variantType+'_current_option_'+multicolumnLoopIndex).text(selectedValue);
    $('.'+productID+'_facets__disclosure_'+multicolumnLoopIndex).removeAttr('open');
    $('.'+productID+'_'+variantType+'_selected_variant_'+multicolumnLoopIndex).text(selectedValue);
    var get_current_color= $('.'+productID+'_color_selected_variant_'+multicolumnLoopIndex).text();
    var get_current_size= $('.'+productID+'_size_selected_variant_'+multicolumnLoopIndex).text();
    var combo_var_title= get_current_color+' / '+get_current_size;
    var new_var_id= '';
    var new_var_image= '';
    var new_var_price= '';
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      if(current_option_loop_text == combo_var_title){
        new_var_id= parseInt($(this).attr('data-var-id'));
        new_var_image= $(this).attr('data-var-image');
        new_var_price= $(this).attr('data-var-price');
      }
    });
    $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',new_var_id);
    $('.'+productID+'_card_img_'+multicolumnLoopIndex+' img').attr('srcset',new_var_image);
    $('.'+productID+'_card_price_'+multicolumnLoopIndex).text(new_var_price);

  } // end updateVariantOnChange()

  // this function runs on the change of SIZE and LOFT radios of pillow bundle products
  // responsible for updating the variation details to add to the cart process
  function updateVariantOnChangePillow(productID,variantType,selectedValue,multicolumnLoopIndex){
    $('.'+productID+'_'+variantType+'_current_option_'+multicolumnLoopIndex).text(selectedValue);
    $('.'+productID+'_facets__disclosure_'+multicolumnLoopIndex).removeAttr('open');
    $('.'+productID+'_'+variantType+'_selected_variant_'+multicolumnLoopIndex).text(selectedValue);
    var get_current_size= $('.'+productID+'_size_selected_variant_'+multicolumnLoopIndex).text();
    var get_current_loft= $('.'+productID+'_loft_selected_variant_'+multicolumnLoopIndex).text();
    var combo_var_title= get_current_size+' / '+get_current_loft;
    var new_var_id= '';
    var new_var_price= '';
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      if(current_option_loop_text == combo_var_title){
        new_var_id= parseInt($(this).attr('data-var-id'));
        new_var_price= $(this).attr('data-var-price');
      }
    });
    $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',new_var_id);
    $('.'+productID+'_card_price_'+multicolumnLoopIndex).text(new_var_price);

  } // end updateVariantOnChangePillow()

  // this function runs on the change of SIZE,FILL,LOFT radios of Duvet Imserts bundle products
  // responsible for updating the variation details to add to the cart process
  function updateVariantOnChangeDuvetInsert(productID,variantType,selectedValue,multicolumnLoopIndex){
    $('.'+productID+'_'+variantType+'_current_option_'+multicolumnLoopIndex).text(selectedValue);
    $('.'+productID+'_facets__disclosure_'+multicolumnLoopIndex).removeAttr('open');
    $('.'+productID+'_'+variantType+'_selected_variant_'+multicolumnLoopIndex).text(selectedValue);
    var get_current_size= $('.'+productID+'_size_selected_variant_'+multicolumnLoopIndex).text();
    var get_current_fill= $('.'+productID+'_fill_selected_variant_'+multicolumnLoopIndex).text();
    var get_current_loft= $('.'+productID+'_loft_selected_variant_'+multicolumnLoopIndex).text();
    var combo_var_title= get_current_size+' / '+get_current_fill+' / '+get_current_loft;
    var new_var_id= '';
    var new_var_price= '';
    $('.'+productID+'_set_prd_variants_'+multicolumnLoopIndex+' option').each(function( index ) {
      var current_option_loop_text= $(this).text();
      if(current_option_loop_text == combo_var_title){
        new_var_id= parseInt($(this).attr('data-var-id'));
        new_var_price= $(this).attr('data-var-price');
      }
    });
    $('.'+productID+'_selected_variant_card_'+multicolumnLoopIndex).attr('data-selected-var',new_var_id);
    $('.'+productID+'_card_price_'+multicolumnLoopIndex).text(new_var_price);
  } // end updateVariantOnChangeDuvetInsert()

  // on change event of SIZE radios of bundle products
  $(document).on('change', '.size_radio_change', function(){
    var currentPrdID= $(this).attr('data-prd-id');
    var get_selected_size= $(this).val();
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    var no_color_exist= $('.'+currentPrdID+'_no_color_exist_'+get_multicolumn_forloop_index).val();
    var no_fill_exist= $('.'+currentPrdID+'_no_fill_exist_'+get_multicolumn_forloop_index).val();
    if(no_color_exist){
      if(no_fill_exist){
        updateVariantOnChangePillow(currentPrdID,'size',get_selected_size,get_multicolumn_forloop_index);
        updateSoldOutPillowLoft(currentPrdID,get_selected_size,get_multicolumn_forloop_index);
      } else{
        updateVariantOnChangeDuvetInsert(currentPrdID,'size',get_selected_size,get_multicolumn_forloop_index);
        updateSoldOutFillLoft(currentPrdID,get_selected_size,get_multicolumn_forloop_index);
      }
    }
    else{
      updateVariantOnChange(currentPrdID,'size',get_selected_size,get_multicolumn_forloop_index);
    }
  });

  // on change event of COLOR radios of bundle products
  $(document).on('change', '.color_radio_change', function(){
    var currentPrdID= $(this).attr('data-prd-id');
    var get_selected_color= $(this).val();
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    updateVariantOnChange(currentPrdID,'color',get_selected_color,get_multicolumn_forloop_index);
    updateSoldOutSize(currentPrdID,get_selected_color,get_multicolumn_forloop_index);
  });

  // on change event of FILL MATERIAL radios of bundle products
  $(document).on('change', '.fill_radio_change', function(){
    var currentPrdID= $(this).attr('data-prd-id');
    var get_selected_fill= $(this).val();
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    updateVariantOnChangeDuvetInsert(currentPrdID,'fill',get_selected_fill,get_multicolumn_forloop_index);
    updateSoldOutLoft(currentPrdID,get_selected_fill,get_multicolumn_forloop_index);
  });

  // on change event of LOFT radios of bundle products
  $(document).on('change', '.loft_radio_change', function(){
    var currentPrdID= $(this).attr('data-prd-id');
    var get_selected_loft= $(this).val();
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    var no_fill_exist= $('.'+currentPrdID+'_no_fill_exist_'+get_multicolumn_forloop_index).val();
    if(no_fill_exist){
      updateVariantOnChangePillow(currentPrdID,'loft',get_selected_loft,get_multicolumn_forloop_index);
    } else{
      updateVariantOnChangeDuvetInsert(currentPrdID,'loft',get_selected_loft,get_multicolumn_forloop_index);
    }
  });

  // on change event of QUANTITY INPUTs of bundle products
  $(document).on('change', '.quantity__input', function(){
    var currentPrdID= $(this).attr('data-prd-id');
    var get_selected_qty= $(this).val();
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    $('.'+currentPrdID+'_selected_variant_card_'+get_multicolumn_forloop_index).attr('data-selected-qty',get_selected_qty);
  });

  // on click event of CARD IMAGE of bundle products
  $(document).on('click', '.bundle_card_img', function () {
    //console.log("click check");
    var get_prd_id= $(this).attr('data-prd-id');
    var get_multicolumn_forloop_index= $(this).attr('data-multi-floop');
    if($(this).hasClass("active_prd")){
      $(this).removeClass('active_prd');
      $('.'+get_prd_id+'_bundle_swiper_li_'+get_multicolumn_forloop_index).removeClass('active_prd');
    } else{
      $(this).addClass('active_prd');
      $('.'+get_prd_id+'_bundle_swiper_li_'+get_multicolumn_forloop_index).addClass('active_prd');
    }
  });

// on click event of ADD SET TO CART of bundle products
$(document).on('click', '.addSetToCart', function () {
  const $button = $(this);
  
  
  // Prevent multiple clicks
  if ($button.prop('disabled')) return;
  $button.prop('disabled', true);
  
  var productATC = {};
  var get_loop_index= $(this).attr('data-loop-index');
  var get_rand_num_loop= $(this).attr('data-rand-num-loop');
  $('.bundle_prds_'+get_loop_index+'_'+get_rand_num_loop+' .single_bundle_slide.active_prd').each(function( index ) {
    var get_var_id= parseInt($(this).find('.selected_variant_card').attr('data-selected-var'));
    var get_var_qty= $(this).find('.selected_variant_card').attr('data-selected-qty');
    //console.log('get_var_id: '+get_var_id);
    if(get_var_id != 0){
      productATC[get_var_id]=get_var_qty;
    }
  });
  //console.log(productATC);
  
  const miniCart = document.querySelector('mini-cart');
  const sections = miniCart?.getSectionsToRender()?.map((s) => s.id) || [];
  
  // Build array of line items for bulk add
  const items = Object.entries(productATC).map(([variantId, quantity]) => ({
    id: parseInt(variantId),
    quantity: parseInt(quantity)
  }));
  
  const body = JSON.stringify({
    items: items,
    sections,
    sections_url: window.location.pathname
  });
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body
  })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(parsedState => {
      //console.log('Products added to cart and sections received');
  
      if (miniCart && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(parsedState);
      }
  
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: parsedState
        }
      }));
  
      if (typeof miniCart?.open === 'function') {
        miniCart.open();
      }
    })
    .catch(error => {
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: error.message
        }
      }));
      
      })

    .finally(() => {
      // Re-enable button after process is complete
      $button.prop('disabled', false);
    });

}); // end add set to cart click event


  
} // end if curated sets page



/** 
    ------------ Klaviyo Teaser ----------------
**/

/* Hiding the klaviyo teaser when cart drawer and menu opens on mobile view */
document.addEventListener('DOMContentLoaded', () => {
  const MOBILE_BREAKPOINT = 768;
  const TEASER_SELECTOR = '.needsclick.kl-teaser-S9QedN';
  const HIDE_CLASS = 'hide-klaviyo-teaser';
  const DRAWERS = [
    'details.menu-drawer-container', // menu drawer
    'cart-drawer details'            // cart drawer
  ];

  const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;
  const teaserEls = () => document.querySelectorAll(TEASER_SELECTOR);
  const toggleTeaser = (hide) => {
    teaserEls().forEach(el =>
      el.classList.toggle(HIDE_CLASS, hide && isMobile())
    );
  };

  DRAWERS.forEach(selector => {
    const details = document.querySelector(selector);
    if (!details) return;

    new MutationObserver(() => {
      toggleTeaser(details.hasAttribute('open'));
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  });

  window.addEventListener('resize', () => {
    if (!isMobile()) toggleTeaser(false);
    else DRAWERS.forEach(selector => {
      const details = document.querySelector(selector);
      if (details && details.hasAttribute('open')) toggleTeaser(true);
    });
  });
});


/** 
    ------------ Discount Field Cart Drawer ----------------
**/

/* Apply discount code via discount field in the cart drawer */
class DiscountField extends HTMLElement{
    constructor(){
        super();
        this.form = this.querySelector("form");
        this.input = this.querySelector("[name=discount]");
        this.submitButton = this.querySelector(".discount-field__submit-btn");
        this.discountError = this.querySelector(".discount_error__msg");

        this.submitButton.addEventListener("click", this.handleApplyDiscount.bind(this));
        //this.form.addEventListener("submit", this.handleApplyDiscount.bind(this));

        this.querySelectorAll(".discount-field__remove-btn").forEach(button => {
            button.addEventListener("click", this.handleRemoveDiscount.bind(this));
        });

        // CLEAR ERROR WHEN USER STARTS TYPING 
        this.input.addEventListener("input", () => {
            this.input.classList.remove("has-error");
            this.discountError.innerHTML = "";
        });
    }

    handleApplyDiscount(e) {
        e.preventDefault();
        const discountCode = this.input.value.trim().toUpperCase();

        //console.log(discountCode);

        if(!discountCode) return;

        const existingDiscounts = this.dataset.discounts || '';
        const discountsArray = existingDiscounts ? existingDiscounts.split(',') : [];

        const discountToPass = discountCode.trim().toUpperCase();

        if(!discountsArray.includes(discountToPass)) {
            discountsArray.push(discountToPass);
        }

        //console.log("Sending codes:", discountsArray);

        this.updateCart(discountsArray.join(','), discountToPass);
    }

    handleRemoveDiscount(e) {
        e.preventDefault();

        const button = e.target.closest('button');
        const discountToRemove = button.dataset.discount;

        const existingDiscounts = this.dataset.discounts || '';
        const discountsArray = existingDiscounts ? existingDiscounts.split(',') : [];
        
        const updatedDiscounts = discountsArray.filter(discount => discount !== discountToRemove);

        this.updateCart(updatedDiscounts.join(','), discountToRemove);
    }
    
    async updateCart(discountCodes, discountCode) {
        this.setLoading(true);

        try {
            const response = await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    discount: discountCodes
                })
            });

            const cart = await response.json();
            console.log(cart);

            let hasError = false;

            const allowedDiscounts = ["MEG", "HCL", "AMANDAKNOX", "DONUT", "KALEE", "FGN", "QATCH", "HOLIDAY"];
            
            const minimumPurchaseForAllowedDiscounts = 500; // $675 minimum amount for free product
            const freeVarId = document.getElementById("free_prd_auto_discount")?.value;
            const freeVarPriceHundreds = document.getElementById("free_prd_auto_discount")?.dataset.price;
            const freeVarPrice = parseInt(freeVarPriceHundreds) / 100;
            const freeVarPrdID = document.getElementById("free_prd_auto_discount")?.dataset.prdid;
            

            // Check if any allowed discount exists
            const hasAllowedDiscount = cart.discount_codes.some(d =>
              allowedDiscounts.includes(d.code?.trim()?.toUpperCase())
            );

            
            // Check if free variant is already in cart
            const isFreeInCart = Array.isArray(cart.items) &&
              cart.items.some(i => String(i.product_id) === String(freeVarPrdID));
            //console.log('test');
            // Check cart subtotal (Shopify uses cents)
            let cartOriginaltotal = (cart.original_total_price || 0) / 100;
            let cartSubtotal = (cart.total_price || 0) / 100;

            let differenceSubtotal = cartOriginaltotal-cartSubtotal;

            const qualifyingSubtotal = cart.items.reduce((sum, item) => {
              // Exclude the free product itself
              if (String(item.product_id) === String(freeVarPrdID)) return sum;

              // line_price is in cents and already discounted
              return sum + (item.line_price / 100);
            }, 0);


            //console.log('qualifyingSubtotal: '+qualifyingSubtotal);

            let meetsMinimum = qualifyingSubtotal >= minimumPurchaseForAllowedDiscounts;

            if(isFreeInCart){
              let freeItems = cart.items.filter(
                item => String(item.product_id) === String(freeVarPrdID)
              );
              let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);
              //console.log('free item quantity: '+totalFreeQty+", cart.item_count: "+cart.item_count+", meetsMinimum: "+meetsMinimum);
              if(totalFreeQty === 1 && cart.item_count > 1 && differenceSubtotal < 100 ){
                //console.log('only 1 free product is in cart and cart have more products except free product');
                //console.log("old cartSubtotal: "+cartSubtotal);
                meetsMinimum = false;
              }
            }
            
            //console.log("meetsMinimum: "+meetsMinimum);
            

            cart.discount_codes.forEach(discount => {
              // Skip error check for allowed free-product discounts
              if (allowedDiscounts.includes(discount.code)) {
                return; 
              }

              if (discount.code === discountCode && discount.applicable === false) {
                hasError = true;
                this.input.classList.add("has-error");
                this.discountError.innerHTML = `There was an error applying the discount code '${discountCode}'`;
              }
            });

            /*
            if(allowedDiscounts.includes(discountCode)){
              if (hasAllowedDiscount) {
                hasError = true;
                this.input.classList.add("has-error");
                this.discountError.innerHTML = `There was an error applying the discount code '${discountCode}'`;
              }
            }
            */
              
            

            this.input.value = '';

            
            // --------------------------------------------
            // AUTO ADD / REMOVE FREE PRODUCT (UPDATED)
            // --------------------------------------------

            // Final condition to add free product
            //const shouldAddFree = hasAllowedDiscount && meetsMinimum;

            let shouldAddFree = false;
            if (discountCodes.length === 0) {
              shouldAddFree = meetsMinimum;
            } else {
              shouldAddFree = hasAllowedDiscount && meetsMinimum;
            }

            //console.log("cartSubtotal: "+cartSubtotal+", meetsMinimum: "+meetsMinimum+", shouldAddFree: "+shouldAddFree);

            // Re-render mini-cart
            async function dispatchCartUpdated() {
              const miniCart = document.querySelector("mini-cart");
              if (!miniCart) return;

              const sectionsToRender = miniCart.getSectionsToRender();
              const parsedState = { sections: {} };

              for (const section of sectionsToRender) {
                const res = await fetch(`/?section_id=${section.section}`, {
                  method: "GET",
                  headers: { "Accept": "text/html" }
                });

                const html = await res.text();
                parsedState.sections[section.id] = html;
              }

              miniCart.renderContents(parsedState);
            }

            if (freeVarId) {
              // ADD FREE PRODUCT
              if (shouldAddFree && !isFreeInCart) {
                //console.log('add free prd');
                await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: freeVarId, quantity: 1 })
                });
              }

              
              if (shouldAddFree && isFreeInCart) {
                let freeItems = cart.items.filter(
                  item => String(item.variant_id) === String(freeVarId)
                );
                let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);
                if(totalFreeQty > 1){
                  //console.log('free product already in cart and change free product to qty 1');
                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      updates: { [freeVarId]: 1 }
                    })
                  }).then(() => dispatchCartUpdated());
                }
              }
              
              
              // REMOVE 1 QTY OF FREE PRODUCT
              if (!shouldAddFree && isFreeInCart) {
                //console.log('remove 1 qty of free product');

                let freeItems = cart.items.filter(
                  item => String(item.variant_id) === String(freeVarId)
                );
                let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);

                if (freeItems && totalFreeQty > 0) {
                  const newQty = totalFreeQty - 1;

                  await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      updates: { [freeVarId]: newQty }
                    })
                  }).then(() => dispatchCartUpdated());
                }
              }
              

            }
            

            // Only re-render cart if no error 
            if (!hasError) {
              await this.reRenderCart();
            }
        } catch (err) {
            console.error(err);
        } finally {
          this.setLoading(false);
        }
    } 

    setLoading(isLoading) {
        if(isLoading){
            this.classList.add("discount-field__loading")
            this.submitButton.disabled = true
        } else {
            this.classList.remove("discount-field__loading")
            this.submitButton.disabled = false;
        }
    }

    async reRenderCart() {
      try {
        
        //console.log("Re-render cart…");

        const miniCart = document.querySelector("mini-cart");
        if (!miniCart) return;

        const sectionsToRender = miniCart.getSectionsToRender();

        // Create an object that matches theme’s expected structure
        const parsedState = { sections: {} };

        // Fetch each section using section_id (NOT sections=)
        for (const section of sectionsToRender) {
          const res = await fetch(`/?section_id=${section.section}`, {
            method: "GET",
            headers: { "Accept": "text/html" }
          });

          const html = await res.text();
          parsedState.sections[section.id] = html;
        }

        // Now parsedState.sections["mini-cart"] exists!
        miniCart.renderContents(parsedState);
        
      } catch (err) {
        console.error("Error re-rendering the cart:", err);
      } 
    }

}
customElements.define('discount-field', DiscountField);


// Detect automatic discounts and add free product
function UpdateFreeProductPerDiscount(evt) {
  const cart = evt;
  if (!cart) return;

  console.log(cart);
  const allowedDiscounts = ["MEG", "HCL", "AMANDAKNOX", "DONUT", "KALEE", "FGN", "QATCH", "HOLIDAY"];
  const minimumPurchaseForAllowedDiscounts = 500; // $675 minimum amount for free product
  const freeVarId = document.getElementById("free_prd_auto_discount")?.value;
  const freeVarPriceHundreds = document.getElementById("free_prd_auto_discount")?.dataset.price;
  const freeVarPrice = parseInt(freeVarPriceHundreds) / 100;
  const freeVarPrdID = document.getElementById("free_prd_auto_discount")?.dataset.prdid;

  if (!freeVarId) return;

  // Ensure discount_codes exists and is an array
  const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
  
  // Check if any allowed discount exi  sts
  const hasAllowedDiscount = discountCodes.some(d =>
    allowedDiscounts.includes(d.code?.trim()?.toUpperCase())
  );

  // Check if free variant is already in cart
  const isFreeInCart = Array.isArray(cart.items) &&
    cart.items.some(i => String(i.product_id) === String(freeVarPrdID));
  //console.log('test2');
  // Check cart subtotal (Shopify gives cents → convert to dollars)
  let cartOriginaltotal = (cart.original_total_price || 0) / 100;
  let cartSubtotal = (cart.total_price || 0) / 100;

  let differenceSubtotal = cartOriginaltotal-cartSubtotal;

  const qualifyingSubtotal = cart.items.reduce((sum, item) => {
    // Exclude the free product itself
    if (String(item.product_id) === String(freeVarPrdID)) return sum;

    // line_price is in cents and already discounted
    return sum + (item.line_price / 100);
  }, 0);


  //console.log('qualifyingSubtotal: '+qualifyingSubtotal);

  let meetsMinimum = qualifyingSubtotal >= minimumPurchaseForAllowedDiscounts;

  //console.log("cartOriginaltotal: "+cartOriginaltotal+", cartSubtotal: "+cartSubtotal+", differenceSubtotal: "+differenceSubtotal+", meetsMinimum: "+meetsMinimum);


  if(isFreeInCart){
    let freeItems = cart.items.filter(
      item => String(item.product_id) === String(freeVarPrdID)
    );
    let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);
    //console.log('free item quantity: '+totalFreeQty+", cart.item_count: "+cart.item_count+", meetsMinimum: "+meetsMinimum);
    if(totalFreeQty === 1 && cart.item_count > 1 && differenceSubtotal < 100 ){
      //console.log('only 1 free product is in cart and cart have more products except free product');
      //console.log("old cartSubtotal: "+cartSubtotal);
      meetsMinimum = false;
    }
  } 

  //console.log('meetsMinimum: '+meetsMinimum);
  // Final condition (must have discount + minimum)
  let shouldAddFree = false;
  if (discountCodes.length === 0) {
    shouldAddFree = meetsMinimum;
  } else {
    shouldAddFree = hasAllowedDiscount && meetsMinimum;
  }


  //console.log("cartSubtotal: "+cartSubtotal+", meetsMinimum: "+meetsMinimum+", shouldAddFree: "+shouldAddFree);

  // Re-render mini-cart
  async function dispatchCartUpdated() {
    const miniCart = document.querySelector("mini-cart");
    if (!miniCart) return;

    const sectionsToRender = miniCart.getSectionsToRender();
    const parsedState = { sections: {} };

    for (const section of sectionsToRender) {
      const res = await fetch(`/?section_id=${section.section}`, {
        method: "GET",
        headers: { "Accept": "text/html" }
      });

      const html = await res.text();
      parsedState.sections[section.id] = html;
    }

    miniCart.renderContents(parsedState);
  }

  //console.log('shouldAddFree: '+shouldAddFree);

  // Add free product
  if (shouldAddFree && !isFreeInCart) {
    //console.log('add free product');
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: freeVarId, quantity: 1 })
    })
    .then(() => dispatchCartUpdated());
  }

  
  if (shouldAddFree && isFreeInCart) {
    let freeItems = cart.items.filter(
      item => String(item.variant_id) === String(freeVarId)
    );
    let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);
    if(totalFreeQty > 1){
      //console.log('free product already in cart and change free product to qty 1');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [freeVarId]: 1 }
        })
      }).then(() => dispatchCartUpdated());
    }
  }

  
  // REMOVE 1 QTY OF FREE PRODUCT
  if (!shouldAddFree && isFreeInCart) {
    //console.log('remove 1 qty of free product');

    let freeItems = cart.items.filter(
      item => String(item.variant_id) === String(freeVarId)
    );
    let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);

    if (freeItems && totalFreeQty > 0) {
      const newQty = totalFreeQty - 1;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [freeVarId]: newQty }
        })
      }).then(() => dispatchCartUpdated());
    }
  }
  

}


// Detect automatic discounts and add free product
// functionality is modified to only set specific variants of product as free
function UpdateFreeProductPerDiscountOnlyMeetsMinimum(evt) {
  const cart = evt;
  if (!cart) return;

  console.log(cart);
  const allowedVariantsForFree = [45972538622177, 45972538818785, 45972538720481]; // the variations of product allowed for free
  const minimumPurchaseForAllowedDiscounts = 250; // $250 minimum amount for free product
  const freeVarId = document.getElementById("free_prd_auto_discount")?.value;

  if (!freeVarId) return;

  // Ensure discount_codes exists and is an array
  const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];

  // Check if free variant is already in cart
  const isFreeInCart = Array.isArray(cart.items) &&
    cart.items.some(i => allowedVariantsForFree.includes(Number(i.variant_id)));
  //console.log('test2');
  // Check cart subtotal (Shopify gives cents → convert to dollars)
  let cartOriginaltotal = (cart.original_total_price || 0) / 100;
  let cartSubtotal = (cart.total_price || 0) / 100;

  let differenceSubtotal = cartOriginaltotal-cartSubtotal;

  const qualifyingSubtotal = cart.items.reduce((sum, item) => {
    // Exclude the free product itself
    if (allowedVariantsForFree.includes(Number(item.id))) return sum;

    // line_price is in cents and already discounted
    return sum + (item.line_price / 100);
  }, 0);


  //console.log('qualifyingSubtotal: '+qualifyingSubtotal);

  let meetsMinimum = qualifyingSubtotal >= minimumPurchaseForAllowedDiscounts;

  //console.log("cartOriginaltotal: "+cartOriginaltotal+", cartSubtotal: "+cartSubtotal+", differenceSubtotal: "+differenceSubtotal+", meetsMinimum: "+meetsMinimum);


  if(isFreeInCart){
    let freeItems = cart.items.filter(
      item => allowedVariantsForFree.includes(Number(item.variant_id))
    );
    let totalFreeQty = freeItems.reduce((sum, item) => sum + item.quantity, 0);
    //console.log('free item quantity: '+totalFreeQty+", cart.item_count: "+cart.item_count+", meetsMinimum: "+meetsMinimum);
    if(totalFreeQty === 1 && cart.item_count > 1 && differenceSubtotal < 100 ){
      //console.log('only 1 free product is in cart and cart have more products except free product');
      //console.log("old cartSubtotal: "+cartSubtotal);
      meetsMinimum = false;
    }
  } 

  //console.log('meetsMinimum: '+meetsMinimum);
  // Final condition (must have discount + minimum)
  let shouldAddFree = false;
  if (discountCodes.length === 0) {
    shouldAddFree = meetsMinimum;
  }


  //console.log("cartSubtotal: "+cartSubtotal+", meetsMinimum: "+meetsMinimum+", shouldAddFree: "+shouldAddFree);

  // Re-render mini-cart
  async function dispatchCartUpdated() {
    const miniCart = document.querySelector("mini-cart");
    if (!miniCart) return;

    const sectionsToRender = miniCart.getSectionsToRender();
    const parsedState = { sections: {} };

    for (const section of sectionsToRender) {
      const res = await fetch(`/?section_id=${section.section}`, {
        method: "GET",
        headers: { "Accept": "text/html" }
      });

      const html = await res.text();
      parsedState.sections[section.id] = html;
    }

    miniCart.renderContents(parsedState);
  }

  //console.log('shouldAddFree: '+shouldAddFree);

  // Add free product
  if (shouldAddFree && !isFreeInCart) {
    //console.log('add free product');
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: freeVarId, quantity: 1 })
    })
    .then(() => dispatchCartUpdated());
  }

  /* 
  This function automatically change quantity of the free product to 1 if customer tries to increase it's quantity from cart drawer
  comment this blow if statment if you want customers to buy more variations of the free product 
  */
  if (shouldAddFree && isFreeInCart) {
    const freeItem = cart.items.find(
      item => allowedVariantsForFree.includes(Number(item.variant_id))
    );

    if (freeItem && freeItem.quantity > 1) {
      //console.log('free product already in cart and change free product to qty 1');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [freeItem.variant_id]: 1 }
        })
      }).then(() => dispatchCartUpdated());
    }
  }

  
  // REMOVE 1 QTY OF FREE PRODUCT
  if (!shouldAddFree && isFreeInCart) {

    //console.log('remove 1 qty of free product');

    // Find the free gift item currently in cart
    const freeItem = cart.items.find(
      item => allowedVariantsForFree.includes(Number(item.variant_id))
    );

    if (freeItem) {
      const freeVariantId = freeItem.variant_id;
      const totalFreeQty = freeItem.quantity;

      if (totalFreeQty > 0) {
        const newQty = totalFreeQty - 1;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: { [freeVariantId]: newQty }
          })
        }).then(() => dispatchCartUpdated());
      }
    }
  }
  

}

// detect product added to cart and update cart, then set auto adding free product based on the discount types
// use function UpdateFreeProductPerDiscountOnlyMeetsMinimum(cart), if you want to only use meets minimum for adding/removing free product
// use function UpdateFreeProductPerDiscount(cart), if you want to use meets minimum with allowed discounts too
$(document).on('click', '.product-form__submit', function(){
  // comment this if statement if you want to enable the automatic add/removal of free product on add to cart
  if($('#enable_discount_field').val()){
    setTimeout(function(){ 
      fetch('/cart.js')
        .then(res => res.json())
        //.then(cart => UpdateFreeProductPerDiscount(cart))
        .then(cart => UpdateFreeProductPerDiscountOnlyMeetsMinimum(cart))
        .catch(err => console.error("Error fetching cart:", err));
    }, 1000);
  }
});
document.addEventListener('cart:updated', function(evt) {
  console.log('cart updated');
  if($('#enable_discount_field').val()){
    setTimeout(function(){ 
      fetch('/cart.js')
        .then(res => res.json())
        //.then(cart => UpdateFreeProductPerDiscount(cart))
        .then(cart => UpdateFreeProductPerDiscountOnlyMeetsMinimum(cart))
        .catch(err => console.error("Error fetching cart:", err));
    }, 1000);
  }
});


/** 
    ------------ Auto Show Sticky Add To Cart on Product Page ----------------
**/

/* Below function is responsible for auto displaying the sticky add to cart when the main add to cart goes out of the viewport on the product pages */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  const sticky = document.querySelector('animate-sticky.sticky-cart-wrapper');
  if (!sticky) return;

  /**
   *  HARD STOP original AnimateSticky behavior
   */
  if (sticky.onScrollHandler) {
    window.removeEventListener('scroll', sticky.onScrollHandler);
  }

  // Safety: prevent it from re-attaching
  sticky.onScroll = function () {};
  sticky.connectedCallback = function () {};

  /**
   *  Our controlled logic
   */
  let atcButton;

  const findATC = () => {
    atcButton = document.querySelector(
      '.product__info-container product-form button[type="submit"]'
    );
  };

  findATC();

  const toggleSticky = () => {
    if (!atcButton) {
      findATC();
      if (!atcButton) return;
    }

    const rect = atcButton.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const isInView = rect.top < vh && rect.bottom > 0;

    if (!isInView) {
      console.log('out of view → add animate');
      sticky.setAttribute('animate', '');
    } else {
      console.log('in view → remove animate');
      sticky.removeAttribute('animate');
    }
  };

  window.addEventListener('scroll', toggleSticky, { passive: true });
  window.addEventListener('resize', toggleSticky);

  document.addEventListener('variant:change', () => {
    findATC();
    toggleSticky();
  });

  toggleSticky();
})();


/** 
    ------------ Landing Page ----------------
**/

/*
new Swiper('.tabbed-col-slider', {
  //loop: true,
  spaceBetween: 20,

  centeredSlides: true,
  //centeredSlidesBounds: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  slideToClickedSlide: true,
  
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  
  breakpoints: {
    0: {
      slidesPerView: 2.5,  // Mobile
      initialSlide: 1
    },
    768: {
      slidesPerView: 3.5,  // Tablet
      initialSlide: 1
    },
    1024: {
      slidesPerView: 5.5,  // Desktop
      initialSlide: 2
    },
    1367: {
      slidesPerView: 5.5,  // Desktop
      initialSlide: 2
    }
  }
});
*/


const swiper = new Swiper('.tabbed-col-slider', {
  spaceBetween: 20,

  centeredSlides: true,
  centeredSlidesBounds: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  slideToClickedSlide: true,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
    0: {
      slidesPerView: 2.5
    },
    768: {
      slidesPerView: 3.5
    },
    1024: {
      slidesPerView: 5.5
    },
    1367: {
      slidesPerView: 5.5
    }
  },

  on: {
    init: function () {
      setCenterSlide(this);
    },
    resize: function () {
      setCenterSlide(this);
    }
  }
});


function setCenterSlide(swiper) {
  const totalSlides = swiper.slides.length;
  const slidesPerView = swiper.params.slidesPerView;

  // Only fix when slides are less or equal to visible area
  if (totalSlides <= Math.ceil(slidesPerView)) {
    const middleIndex = Math.floor(totalSlides / 2);
    swiper.slideTo(middleIndex, 0);
  }
}